import { API_ENDPOINTS } from "./api-endpoints";
import { ServiceBase } from "./service-base";

export class ModuleEntitlementsService {

    public static async getDocSurveyEntitlement(): Promise<boolean | null> {
        return ServiceBase.get<boolean>(`${API_ENDPOINTS.v1.moduleEntitlements}/DocSurvey`);
    }
}
